import React from 'react';
import { formatDate, formatPrice, timeDiff } from '../../utils/Common';

const DueCollectionPDFData = (props) => {
  const {
    balanceData,
    paymentList,
    paymentAccountList,
    index
} = props;



const paymentData = paymentList.data ? paymentList.data : paymentList;
const paymentAccountData = paymentAccountList.data ? paymentAccountList.data : paymentAccountList;

  const createdDate = new Date(balanceData?.created_at);

  return (
    <>
      <div className="border-b-[1px] text-center text-sm border-solid  border-[#E7EBF4] py-[13px] font-nunito grid grid-cols-10 items-start">

      <div className='text-center col-span-1 text-[#000] font-[600]'>
     {index}
      </div>

      <div className="text-center col-span-2">
        <h1 className=" text-[#000] font-[600]">{formatDate(balanceData?.created_at)}</h1>
        <p className=" text-[#87889E] font-[500] text-sm">{timeDiff(createdDate)}</p>
      </div>

      <div className="text-[#000] font-[500] text-center col-span-2">
      <p>{balanceData?.payment_type?.type_name}</p>
      <p>{balanceData?.payment_type_category?.payment_category_name}</p>
      <p>{balanceData?.payment_type_category?.account_number}</p>
      </div>


      <div className="text-[#000] font-semibold text-center col-span-1">
        <p className="text-[#000] font-[500] text-md">{balanceData?.status}</p>
      </div>


      <div className="text-[#000] font-[500] text-center col-span-1">
        <p className="text-[#000] font-[500] text-md">{balanceData?.type}</p>
      </div>

      <div className=" text-[#000] font-[500] text-center col-span-1">{balanceData?.ref}</div>

      <div className=" text-[#000] font-[500]  text-center col-span-1">{Number.parseFloat(balanceData?.payment_amount).toFixed(2)}</div>
    </div>

    </>
  );
};
DueCollectionPDFData.defaultProps = { className: null };
export default DueCollectionPDFData;